export default __webpack_public_path__ + "static/media/medical-expenses.417509cc.png";